//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Debounce from "lodash.debounce";
import { getStorage } from "@/js/utils";
export default {
    name: "field",
    props: {
        placeholder: String,
        type: String,
        label: String,
        fieldType: String,
        value: [String, Number],
        max: Number,
        debounce: Number,
        path: Object,
        bindType: String,
    },
    mounted() {
        if (this.debounce) {
            this._debounce = Debounce(() => {
                this.$emit("on-change", this.currentValue);
            }, this.debounce);
        }
        this.input = this.$refs.input;
        if (this.value) {
            this.input.value = this.value;
        }
    },
    data() {
        return {
            isLabelShow: false,
            isErrorShow: false,
            old_value: "",
            showClear: false,
            // errorTrigger: ''
            errorMsg: "",
        };
    },
    computed: {
        selectText() {
            const banks = getStorage("session", "banks");
            let text = "请选择开户行";
            if (this.fieldType === "bank" && !!this.value) {
                const bankInfo = banks.find(
                    (item) => item.bankID === this.value
                );
                text = bankInfo ? bankInfo.bankName : "请选择开户行";
            }
            return text;
        },
        fieldText() {
            switch (this.fieldType) {
                case "cardnum":
                    return "银行卡号";
                case "bank":
                    return "开户银行";
                case "mobile":
                    return "手机号";
                case "vercode":
                    return "验证码";
            }
            return "";
        },
        realVal() {
            console.log("realVal updated", this.value);
            return this.type === "select" ? this.value : this.input.value;
        },
    },
    watch: {
        old_value(val) {
            if (this._debounce) {
                this._debounce();
            }
            this.isLabelShow = !!val;
            this.showClear = !!val;
            this.$emit("input", val);
        },
        value() {
            if (this.type === "input") {
                this.input.value = this.value;
                this.inputChange();
            }
        },
    },
    methods: {
        isNotNull() {
            if (!this.realVal) {
                this.isErrorShow = true;
                this.errorMsg = `${this.fieldText}不能为空`;
                return false;
            }
            return true;
        },
        isInteger() {
            if (!/^\d{1,}$/.test(this.realVal.replace(/\s/g, ""))) {
                this.isErrorShow = true;
                this.errorMsg = `${this.fieldText}必须为数字`;
                return false;
            }
            return true;
        },
        validField() {
            this.isErrorShow = false;
            this.errorMsg = "";

            switch (this.fieldType) {
                case "cardnum":
                    const isCorrectCardNum = () => {
                        if (
                            !/^([1-9]{1})((\d|\*){11,19})$/.test(
                                this.realVal.replace(/\s/g, "")
                            )
                        ) {
                            this.isErrorShow = true;
                            this.errorMsg = "请输入正确的银行卡号";
                            return false;
                        }
                        return true;
                    };
                    return this.isNotNull() && isCorrectCardNum();
                case "bank":
                    return this.isNotNull();
                case "mobile":
                    const isCorrectMobile = () => {
                        if (
                            !/^(13|14|15|16|17|18|19)(\d|\*){9}$/.test(
                                this.realVal
                            )
                        ) {
                            this.isErrorShow = true;
                            this.errorMsg = "请输入正确的手机号";
                            return false;
                        }
                        return true;
                    };
                    return this.isNotNull() && isCorrectMobile();
                case "vercode":
                    const isCorrectVercode = () => {
                        if (!/^\d{6}$/.test(this.realVal)) {
                            this.isErrorShow = true;
                            this.errorMsg = "请输入正确的验证码";
                            return false;
                        }
                        return true;
                    };
                    return (
                        this.isNotNull() &&
                        this.isInteger() &&
                        isCorrectVercode()
                    );
            }

            return true;
        },
        clear() {
            this.input.value = "";
            this.old_value = "";
            this.input.focus();
        },
        inputChange() {
            let input = this.input;
            let start = input.selectionStart;
            if (this.fieldType === "cardnum") {
                const reg =
                    this.bindType === "auto"
                        ? /(\d{4})(\*{0,4})(\*{0,4})(\*{0,4})(\d{0,4})/
                        : /(\d{4})(\d{0,4})(\d{0,4})(\d{0,4})(\d{0,4})/;
                input.value = input.value
                    .replace(/\s/g, "")
                    .replace(reg, "$1 $2 $3 $4 $5");
            } else {
            }

            if (input.value.substr(input.value.length - 1) == " ") {
                input.value = input.value.substr(0, input.value.length - 1);
            }
            if (this.old_value.length < input.value.length) {
                if (this.fieldType === "cardnum") {
                    switch (start) {
                        case 5:
                            start += 1;
                            break;
                        case 10:
                            start += 1;
                            break;
                        case 15:
                            start += 1;
                            break;
                        case 20:
                            start += 1;
                            break;
                    }
                } else {
                }
            }
            setTimeout(() => {
                input.selectionStart = start;
                input.selectionEnd = start;
            }, 10);

            this.old_value = input.value;
        },
        onfocus() {
            this.$emit("on-focus");
            if (this.input.value) {
                this.showClear = true;
            } else {
                this.showClear = false;
            }
            this.isErrorShow = false;
            this.isLabelShow = true;
        },
        onblur() {
            if (!this.old_value) {
                this.isLabelShow = false;
            }
            this.validField();
            setTimeout(() => {
                this.showClear = false;
                this.$emit("on-blur");
            }, 0);
        },
    },
};
